import { render } from "./get-started.vue?vue&type=template&id=1ab3db63&lang=pug"
import script from "./get-started.vue?vue&type=script&lang=js"
export * from "./get-started.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__